import { forwardRef } from 'react';
import { StyledHr } from './styled';

const Hr = forwardRef((props, ref) => <StyledHr ref={ref} {...props} />);

export default Hr;
